"use client";
import { useEffect, useState } from "react";
import { X } from "lucide-react";

const VideoModal = ({ open, url, onClose }) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (open) {
      requestAnimationFrame(() => requestAnimationFrame(() => setActive(true)));
    } else {
      setActive(false);
    }
  }, [open]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousPaddingRight = document.body.style.paddingRight;

    if (open) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    };
  }, [open]);

  if (!open) return null;

  const videoSrc = url ? url.replace("watch?v=", "embed/") : null;

  return (
    <div className="fixed inset-0 z-999 flex items-center justify-center bg-black/70 px-4 py-6 top-0">
      <div
        className={`relative bg-white overflow-hidden max-w-200 w-full aspect-video video-modal ${active ? "video-modal-open" : ""
          }`}
        style={{ minHeight: "500px" }}
      >
        <button
          className="cursor-pointer absolute top-2 right-2 z-10 bg-white rounded-full p-1 shadow"
          onClick={onClose}
        >
          <X className="w-6 h-6 text-black" />
        </button>

        {videoSrc && (
          <iframe
            key={videoSrc}
            className="w-full h-full"
            src={videoSrc}
            title="Student Story"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
};

export default VideoModal;
